import styled from 'styled-components';

export const TitleStyled = styled.h2`
	color: ${({ theme }) => theme.colors.primaryColor};
	font-weight: 500;
	font-size: 21px;
	line-height: 26px;
	letter-spacing: 0.15px;
	&.color-white {
		color: white;
	}

	&.color-dark {
		color: ${({ theme }) => theme.colors.quinaryColor};
	}

	&.large {
		font-size: 23px;
		line-height: 26px;
		letter-spacing: 0.15px;
	}
	&.extra-large {
		font-size: 25px;
		line-height: 34px;
		letter-spacing: 0.2px;
	}
`;

export const LabelStyled = styled.h4`
	color: ${({ theme }) => theme.colors.tertiaryColor};
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.13px;
	width: 30%;
	min-width: 60px;
	&.color-white {
		color: white;
	}
	@media (max-width: ${({ theme }) => `${theme.variables.wrapBreakPoint}px`}) {
		width: 100%;
	}
`;

export const ValueStyled = styled.h4`
	color: ${({ theme }) => theme.colors.quinaryColor};
	font-weight: 500;
	width: 70%;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.13px;
	text-transform: capitalize;

	&.color-white {
		color: white;
	}

	&.break-word {
		word-break: break-all;
	}

	&.hyphens {
		hyphens: auto;
	}

	&.distance-learning-course {
		display: inline-block;
		color: ${({ theme }) => theme.colors.tertiaryColor};
		border: 1.25px solid ${({ theme }) => theme.colors.tertiaryColor};
		&.color-white {
			color: white;
			border: 1.25px solid white;
		}
		border-radius: 3px;
		font-size: 14px;
		line-height: 14px;
		letter-spacing: 0.5px;
		font-weight: 500;
		text-transform: uppercase;
		padding: 3px;
		text-align: center;
		width: auto;
		@media (max-width: ${({ theme }) =>
				`${theme.variables.wrapBreakPoint}px`}) {
			width: 100%;
		}
	}

	@media (max-width: ${({ theme }) => `${theme.variables.wrapBreakPoint}px`}) {
		width: 100%;
	}
`;

// Font for when on mobile and is a remote course
export const MobileRemoteMessageStyled = styled.p`
	font-weight: 400;
	font-size: 16px;
	line-height: 21px;
	letter-spacing: 0.13px;
	width: 100%;
	text-align: center;
	color: white;
`;
